module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('form', {}, [_c('div', {}, [_c('label', {
    attrs: {
      "for": "ecard-message"
    }
  }, [_vm._v("ข้อความเชิญชวน")]), _vm._v(" "), _c('text-counter', {
    staticClass: "fs-xs fl-right",
    attrs: {
      "text": _vm.value.message,
      "limit": _vm.messageMaxLength
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.message),
      expression: "value.message"
    }],
    staticClass: "form__textarea",
    attrs: {
      "id": "ecard-message"
    },
    domProps: {
      "value": (_vm.value.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validator.$errors['value.message'].empty),
      expression: "validator.$errors['value.message'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกข้อความอวยพร")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validator.$errors['value.message'].maxLength),
      expression: "validator.$errors['value.message'].maxLength"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("ข้อความต้องยาวไม่เกิน " + _vm._s(_vm._f("comma")(_vm.messageMaxLength)) + " ตัวอักษร")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "ecard-type"
    }
  }, [_vm._v("เนื่องในวัน")]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.type),
      expression: "value.type"
    }],
    attrs: {
      "id": "ecard-type"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.value, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onTypeChange]
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.$const.SPECIAL_EVENT_TYPES.BIRTHDAY
    }
  }, [_vm._v("วันเกิด")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.$const.SPECIAL_EVENT_TYPES.ANNIVERSARY
    }
  }, [_vm._v("วันครบรอบ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.$const.SPECIAL_EVENT_TYPES.OTHER
    }
  }, [_vm._v("อื่น ๆ")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.custom_type),
      expression: "value.custom_type"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.value.type === _vm.$const.SPECIAL_EVENT_TYPES.OTHER),
      expression: "value.type === $const.SPECIAL_EVENT_TYPES.OTHER"
    }],
    ref: "customType",
    staticClass: "form-control form__text",
    attrs: {
      "type": "text",
      "name": "custom_type",
      "id": "ecard-custom",
      "placeholder": "วันขึ้นบ้านใหม่"
    },
    domProps: {
      "value": (_vm.value.custom_type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "custom_type", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validator.$errors['value.custom_type'].empty),
      expression: "validator.$errors['value.custom_type'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกโอกาสพิเศษ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "ecard-name"
    }
  }, [_vm._v("ของ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.name),
      expression: "value.name"
    }],
    staticClass: "form-control form__text",
    attrs: {
      "type": "text",
      "name": "title",
      "id": "ecard-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validator.$errors['value.name'].empty),
      expression: "validator.$errors['value.name'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกชื่อ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "ecard-date"
    }
  }, [_vm._v("ในวันที่")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4 pr-0"
  }, [_c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.day),
      expression: "value.day"
    }],
    attrs: {
      "id": "ecard-date",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.value, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- วัน -")]), _vm._v(" "), _vm._l((_vm.dayList), function(item) {
    return _c('option', {
      key: item.value,
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.month),
      expression: "value.month"
    }],
    attrs: {
      "id": "ecard-month",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.value, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- เดือน -")]), _vm._v(" "), _vm._l((_vm.monthList), function(item) {
    return _c('option', {
      key: item.value,
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {}, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "ecard-target"
    }
  }, [_vm._v("เป้าหมาย")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.target),
      expression: "value.target"
    }],
    staticClass: "form-control form__text",
    attrs: {
      "type": "number",
      "placeholder": "กรุณากรอกจำนวนเงิน",
      "id": "ecard-target",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.target)
    },
    on: {
      "keydown": _vm.targetKeyDown,
      "keyup": _vm.targetKeyUp,
      "focus": _vm.targetFocus,
      "blur": _vm.targetUnfocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "target", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validator.$errors['value.target'].empty),
      expression: "validator.$errors['value.target'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเป้าหมาย")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validator.$errors['value.target'].minimum),
      expression: "validator.$errors['value.target'].minimum"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("จำนวนเงินขั้นต่ำ " + _vm._s(_vm._f("comma")(_vm.targetMinimum)) + " บาท")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {}, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "ecard-deadline"
    }
  }, [_vm._v("กำหนดวันสิ้นสุดการระดมเงิน")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-pickdate"
  }, [_c('span', {
    staticClass: "ic-calendar"
  }), _c('input', {
    directives: [{
      name: "pikaday",
      rawName: "v-pikaday:selected",
      value: (_vm.setEndDate),
      expression: "setEndDate",
      arg: "selected"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.value.end_date),
      expression: "value.end_date"
    }],
    staticClass: "form-control form__text -pickdate",
    attrs: {
      "placeholder": "31/01/2018",
      "type": "text",
      "id": "ecard-deadline",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.value.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "end_date", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.showEcardForm) ? _c('div', {
    staticClass: "mt-30"
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.send_ecard),
      expression: "value.send_ecard"
    }],
    staticClass: "-lg",
    attrs: {
      "type": "checkbox",
      "name": "",
      "id": "ecard-check"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.send_ecard) ? _vm._i(_vm.value.send_ecard, null) > -1 : (_vm.value.send_ecard)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.send_ecard,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "send_ecard", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "send_ecard", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "send_ecard", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ecard-check"
    }
  }, [_vm._v("ส่งเป็น e-card เพื่อให้ครอบครัวหรือเพื่อนของคุณได้รู้ถึงเรื่องราวดีๆ")])])]) : _vm._e(), _vm._v(" "), (_vm.value.send_ecard && _vm.showEcardForm) ? _c('div', [_c('send-email-form', {
    ref: "emailForm",
    model: {
      value: (_vm.value.send_ecard_emails),
      callback: function($$v) {
        _vm.$set(_vm.value, "send_ecard_emails", $$v)
      },
      expression: "value.send_ecard_emails"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-remark lh1-2"
  }, [_vm._v("*ระบบจะส่ง e-card ของคุณทันทีที่การบริจาคของคุณสำเร็จ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "_clearfix mt-30"
  }, [_c('div', {}, [_c('button', {
    staticClass: "ma-auto btn btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.submitButtonText))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5cbe618","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/pages/special-events/form.vue
// module id = 1116
// module chunks = 1